module.exports = __webpack_public_path__ + "img/status-promotion.937b75ba.png";